import { render, staticRenderFns } from "./fuwuNav.vue?vue&type=template&id=65c8bbbe&"
import script from "./fuwuNav.vue?vue&type=script&lang=js&"
export * from "./fuwuNav.vue?vue&type=script&lang=js&"
import style0 from "./fuwuNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports